export enum AppRoute {
  Blotter = 'blotter',
}
